import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchPlatformUsers } from '@/api/users/usersApi';
import type { PlatformUser } from '@/api/users/usersApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import { ADMIN_LIST_PAGE_SIZE } from '@/constants/adminPagination';
import { PLATFORM_USERS_QUERY_KEY } from '@/constants/queryKeys';

export function usePlatformUsersQuery(
  page: number,
  search: string
): UseQueryResult<PaginatedResult<PlatformUser>, Error> {
  return useQuery({
    queryKey: [...PLATFORM_USERS_QUERY_KEY, page, search],
    queryFn: function loadPlatformUsers() {
      return fetchPlatformUsers(page, ADMIN_LIST_PAGE_SIZE, search);
    },
    placeholderData: keepPreviousData,
  });
}
